// ---- Imports ---- //
import { XCloseButton } from "../xCloseButton";
import { AlertProvider, useAlertContext } from "./context";

// ---- Styles ---- //
import { Container, Modal, Backdrop, Title } from "./styles";
import { AlertHeader, AlertBody, AlertFooter, Message, Button } from "./styles";

/** Main Component
 * @param {ReactNode} children - The content that will open the alert when clicked, usually a AlertTrigger
 * @param {string} title - The title of the alert
 * @param {string} message - The message of the alert
 * @param {function} onConfirm - The function to be called when the confirm button is clicked
 */
const Alert = ({ children, title, message, onConfirm }) => {
	return (
		<AlertProvider title={title} message={message} onConfirm={onConfirm}>
			{children}
			<AlertContent />
		</AlertProvider>
	);
};

/** Alert Trigger
 * @param {ReactNode} children - The content that will open the alert when clicked
 */
const AlertTrigger = ({ children }) => {
	const { openAlert } = useAlertContext();
	return (
		<div onClick={openAlert} onKeyDown={openAlert}>
			{children}
		</div>
	);
};

/** Alert Content **/
const AlertContent = () => {
	const { title, message, isAlertLoading, isOpen, closeAlert, confirmAlert } =
		useAlertContext();

	if (!isOpen) return null;
	return (
		<Container>
			<Modal>
				<AlertHeader>
					<Title>{title}</Title>
					<XCloseButton toClose={closeAlert} />
				</AlertHeader>
				<AlertBody>
					<Message>{message}</Message>
				</AlertBody>
				<AlertFooter>
					<Button onClick={closeAlert} disable={isAlertLoading} className="cancel">
						Cancelar
					</Button>
					<Button
						onClick={confirmAlert}
						primary
						disable={isAlertLoading}
						className="confirm"
					>
						Confirmar
					</Button>
				</AlertFooter>
			</Modal>
			<Backdrop onClick={closeAlert} />
		</Container>
	);
};

// ---- Custom Hooks ---- //
function useCloseAlert() {
	const { closeAlert } = useAlertContext();
	closeAlert();
}

// ---- Export ---- //
export { Alert, AlertTrigger, useCloseAlert, AlertContent };
